import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class RegisterId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): RegisterId {
    return new RegisterId(value);
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
